export const isAboutOpenSelector = (state) => state.ui.isAboutOpen;
